<template lang="pug">
    d2-container.page
            font(class='index-title') 欢迎访问天天有网球后台管理系统
            img(src="./image/index-footer.png" alt="logo")
            template(slot="footer")
           
</template>

<script>
import D2HelpBtn from "./components/d2-help-btn";
import D2Badge from "./components/d2-badge";

export default {
  components: {
    D2HelpBtn,
    D2Badge
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/public.scss";

.page {
  position: relative;
  a {
    margin-left: 5px;
  }
  .page__btn-group {
    color: $color-text-placehoder;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 20px;
    span {
      color: $color-text-sub;
      &:hover {
        color: $color-text-main;
      }
    }
  }

  .index-title {
    width: 540px;
    height: 50px;
    font-size: 36px;
    font-weight: 400;
    color: #02b90d;
    display: block;
    margin: 6% auto;
  }

  img {
    position: absolute;
    width: 488px;
    height: 424px;
    margin-left: 55%;
    bottom: 0;
  }
}
</style>
